import React from 'react';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';

import { changeFormField } from 'apps/auth/actions/formAction';
import InputBase from 'apps/auth/components/form-multi/InputBase';
import { notValidateUpdateValue, validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';
import { inputPropType } from 'apps/auth/helpers/customPropTypes';
import { getInputMode, getPlaceholderRule, isMaskPattern, padMaskPattern, stripMaskSeparators } from 'apps/auth/helpers/fieldMask';

const NewPanField = ({ field, maskForInput = '', toCountry, ...props }) => {
    const getRawValue = (input) => {
        if (isMaskPattern(field.mask)) {
            return stripMaskSeparators(input, field.mask, field.checkRegexp);
        }
        return input ? input.replace(/\D/g, '') : '';
    };

    const handlerChange = (e) => {
        e.preventDefault();
        if (!field.isReadOnly) {
            const value = getRawValue(e.target.value);
            notValidateUpdateValue(props.formName, value, field, props.changeFormField).then(() => {
                if (props.onChangeHandler) {
                    props.onChangeHandler(value, field.name);
                }
            });
        }
    };

    const handlerBlur = (e) => {
        e.preventDefault();
        const value = props.pan?.value ?? '';
        validationAndUpdateValue(props.formName, value, field, props.changeFormField, props.binInfoError, toCountry?.migrationOnly).then((newField) => {
            if (props.onBlurHandler) {
                props.onBlurHandler(value, newField);
            }
        });
    };
    const getMask = () => {
        if (field.isReadOnly) {
            return '999999 ****** 9999999';
        }
        if (isMaskPattern(field.mask)) {
            return padMaskPattern(field.mask);
        }
        if (maskForInput) {
            return maskForInput;
        }
        return '9999 9999 9999 9999999';
    };

    const handleFocus = (e) => {
        if (field.isReadOnly) return;
        if (props.onFocus) props.onFocus(e);
        const moveCaretToEnd = () => {
            const input = props.panInputRef?.current;
            try {
                if (input && typeof input.setSelectionRange === 'function') {
                    const length = input.value?.length ?? 0;
                    input.setSelectionRange(length, length);
                }
            } catch (err) {
                // ignore
            }
        };
        requestAnimationFrame(() => {
            moveCaretToEnd();
            setTimeout(moveCaretToEnd, 0);
        });
    };

    return (
        <InputMask
            mask={getMask()}
            maskChar={null}
            value={field.value ?? ''}
            readOnly={field.isReadOnly}
            onFocus={field.isReadOnly ? null : handleFocus}
            onChange={handlerChange}
            onBlur={handlerBlur}
            onPaste={props.onPaste}
            formatChars={{ 9: '[0-9]', '*': '[·]', '#': getPlaceholderRule(field.mask, field.checkRegexp) }}
        >
            {(inputProps) => (
                <input
                    {...inputProps}
                    autoComplete={'off'}
                    name={field.name}
                    type={field.isReadOnly ? 'text' : 'tel'}
                    inputMode={field.isReadOnly ? undefined : getInputMode(field.checkRegexp, field.mask)}
                    readOnly={field.isReadOnly}
                    ref={props.panInputRef}
                />
            )}
        </InputMask>
    );
};

const PanField = InputBase(NewPanField, true);

PanField.propTypes = inputPropType(['pan', 'phone']);

export default connect(null, { changeFormField })(PanField);
